var sorter = {
    sortedByText: 'Clasificado en orden de {{type}}, {{direction}}',
    sortBy: 'Ordenar Por:',
    postedDate: 'Disputas Fecha',
    amount: 'Disputas Monto',
    status: 'Estatus',
    sortOrder: '{{type}}, clasificar en orden de {{direction}}',
    disputeId: 'ID de disputa',
    description: 'Disputas Transacción'
};
export default sorter;
//# sourceMappingURL=sorter.js.map